import React from 'react';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { useEditorContext } from '../../context/editor-context';
import { estimateTotalDuration, estimateSizeMB, formatDurationMinutes } from '../../utils/text-stats';

interface SummarySectionProps {
  selectedResolutions: number;
}

export const SummarySection: React.FC<SummarySectionProps> = ({ selectedResolutions }) => {
  const { form } = useEditorContext();
  const { spacing, fontSize } = useResponsiveSizes();

  const scripts = form.scenes.map(s => s.script);
  const totalSeconds = estimateTotalDuration(scripts);
  const sizeMB = estimateSizeMB(totalSeconds, selectedResolutions);

  const rows: { label: string; value: string }[] = [
    { label: 'Escenas', value: String(form.scenes.length) },
    { label: 'Duración estimada', value: formatDurationMinutes(totalSeconds) },
    { label: 'Resoluciones', value: String(selectedResolutions) },
    { label: 'Tamaño aprox.', value: sizeMB > 0 ? `${sizeMB} MB` : '—' }
  ];

  return (
    <div>
      <span
        style={{
          fontSize: fontSize.sm,           // template: .settings__block-title 11px
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.6,
          color: C.textLabel,
          display: 'block',
          marginBottom: spacing.sm
        }}
      >
        Resumen
      </span>

      <div
        style={{
          background: C.surface,
          borderRadius: 8,
          padding: spacing.sm
        }}
      >
        {rows.map((row, i) => (
          <div
            key={row.label}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: `${spacing.xs}px 0`,
              borderBottom: i < rows.length - 1 ? `1px solid ${C.border}` : 'none'
            }}
          >
            <span style={{ fontSize: fontSize.sm, color: C.textSecondary }}>{row.label}</span>
            <span style={{ fontSize: fontSize.sm, fontWeight: 500, color: C.textPrimary }}>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
